import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../modules/utils/handleError';
import { translation } from '../../_helpers/Translate';
import { AttachChildApi } from './AttachChildApi';
import { NCALayerSign } from '../../components/NCALayer/NCALayerSign';
import { DocumentApi } from '../../passport/PassportService';

export const attachChildDucksModule = 'attachChildDucks';
const LOADING = `${attachChildDucksModule}/LOADING`;
const SET_APPLICATIONS = `${attachChildDucksModule}/SET_APPLICATIONS`;
const CLEAR_STATE = `${attachChildDucksModule}/CLEAR_STATE`;

const initialState = {
  loading: false,
  data: [],
  pageNumber: 1,
  totalElements: 0
};

export const clearState = () => ({ type: CLEAR_STATE });

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [SET_APPLICATIONS]: (state, action) => {
    state.data = action.data;
    state.pageNumber = action.pageNumber;
    state.totalElements =
      action.pageNumber === 1 ? action.totalElements : state.totalElements;
  },
  [CLEAR_STATE]: () => initialState
});

export const getAllRequests = (filter, iin) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const filterV = { ...filter, requesterIin: iin };
    const { data } = await AttachChildApi.loadRequests(JSON.stringify(filterV));
    dispatch({
      type: SET_APPLICATIONS,
      data: data.result.content,
      pageNumber: data.pageNumber,
      totalElements: data.totalElements
    });
  } catch (er) {
    handleError(er, translation('attachChildDucks_loadRequesterFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export function downloadFile(value) {
  const download = data => {
    let element = document.createElement('a');
    document.body.appendChild(element);
    element.style.display = 'none';

    let blob = new Blob([data], { type: 'octet/stream' });
    let url = window.URL.createObjectURL(blob);
    element.href = url;
    element.download = value.documentName;
    element.click();
    window.URL.revokeObjectURL(url);
  };

  DocumentApi.download(value.documentLink, 1).then(response => {
    download(response.data);
  });
}
const fileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
  });

export const makeApplication = (
  childIin,
  requesterIin,
  applicantValues,
  close,
  filter
) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { parentStatus, childIin, files } = applicantValues;
    const base64Files = await Promise.all(
      files.map(async file => {
        const base64 = await fileToBase64(file);
        return {
          name: file.name,
          format: file.type,
          data: base64
        };
      })
    );

    const { data } = await AttachChildApi.getSignature({
      childIin,
      parentStatus,
      supportingDocuments: base64Files
    });
    const signature = await NCALayerSign(data.result);

    await AttachChildApi.makeApplication({
      childIin,
      parentStatus,
      supportingDocuments: base64Files,
      signature
    });

    close();
    dispatch(getAllRequests(filter, requesterIin));
  } catch (er) {
    handleError(er, translation('attachChildDucks_makeApplicationFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
